
import React, { useState, useEffect, Fragment } from 'react';
import Popover from 'react-tiny-popover';
import PropTypes from 'prop-types';

const GridInfoBox = React.forwardRef((props, ref) => {
  const {
    Positions,
    Align,
    InfoBoxButtonInner,
    updatePanels,
    containerClassName,
    Panels,
    btnWidth,
    footNotes,
    footNoteList,
  } = props;
  const [boxOpen, setBoxOpen] = useState(false);
  const [boxPanels, setBoxPanels] = useState(Panels);

  const getFootNoteLabel = (footnotes) => {
    let label = '';
    if (footnotes.length > 1) {
      const labelDivs = [];
      footnotes.forEach(code => {
        const footNoteText = footNoteList[code] ? footNoteList[code].footnoteText : '';
        labelDivs.push(<div>[{code}] {footNoteText}</div>);
      });
      return <Fragment>{labelDivs}</Fragment>;
    }
    if (footnotes.length === 1) {
      const code = footnotes[0];
      label = footNoteList[code] ? footNoteList[code].footnoteText : '';
      return <div>[{code}] {label}</div>;
    }
    return '';
  }

  useEffect(() => {
    const contents = [];
    contents.push(getFootNoteLabel(footNotes));
    contents.push(<div>External sources of data are not MRC accredited</div>);
    contents.push(<div>* Projections relatively unstable, use with caution</div>);
    setBoxPanels(contents);
  }, [footNotes]);

  // iterate through a collection of panels
  const renderInfoBoxPanels = () => {
    const ret = (
      <div style={updatePanels ? {} : { paddingTop: '5px' }} onClick={e => e.stopPropagation()}>
        {
          boxPanels.map(x => <div key={`${x}-unique-value`}>{x}</div>)
        }
      </div>
    );
    return ret;
  };

  const handleEllipsisClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setBoxOpen(!boxOpen);
    props.handleClick();
  };

  // https://github.com/alexkatz/react-tiny-popover
  const popoverProps = {
    isOpen: boxOpen,
    position: Positions,
    align: Align,
    padding: 2,
    transitionDuration: 0.01,
    // add small delay to onClickOutside to fix bug
    // where event in ToolPalette prevented this from finishing
    onClickOutside: () => setTimeout(() => setBoxOpen(false), 30),
    content: renderInfoBoxPanels(),
    containerClassName,
  };


  return (
    <Popover ref={ref} {...popoverProps}>
      <button
        type="button"
        onClick={e => handleEllipsisClick(e)}
        className="ibox-ellipsis-btn"
        data-test="cacActionBtn"
        style={{ width: btnWidth }}
      >
        {InfoBoxButtonInner}
      </button>
    </Popover>
  );
});

GridInfoBox.propTypes = {
  updatePanels: PropTypes.func,
  Panels: PropTypes.arrayOf(PropTypes.object),
  Positions: PropTypes.arrayOf(PropTypes.oneOf(['top', 'right', 'left', 'bottom'])).isRequired,
  Align: PropTypes.oneOf(['start', 'center', 'end']).isRequired,
  InfoBoxButtonInner: PropTypes.element,
  containerClassName: PropTypes.string.isRequired,
  forwardRef: PropTypes.shape({}),
  btnWidth: PropTypes.string,
  handleClick: PropTypes.func,
  footNotes: PropTypes.instanceOf(Array),
  footNoteList: PropTypes.shape({}),
};

GridInfoBox.defaultProps = {
  btnWidth: '100%',
  handleClick: () => {},
  Panels: [],
  footNotes: [],
  footNoteList: {},
}

export const InfoBoxSpacer = props => {
  const { Height, boxClassName } = props;

  return (
    <div style={{ height: Height }} className={boxClassName} />
  );
};

InfoBoxSpacer.propTypes = {
  boxClassName: PropTypes.string.isRequired,
  Height: PropTypes.string,
};

export default GridInfoBox;
